import { render } from "./PlantillasMov.vue?vue&type=template&id=3354f009&scoped=true"
import script from "./PlantillasMov.vue?vue&type=script&lang=js"
export * from "./PlantillasMov.vue?vue&type=script&lang=js"

import "./PlantillasMov.vue?vue&type=style&index=0&id=3354f009&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3354f009"]])

export default __exports__